export type Persona = 'recruiter' | 'engineer'

export type Theme = 'light' | 'dark' | 'system'

export type Locale = 'en' | 'fr'

export interface Axes {
  density: number // 0..1 (0=airy, 1=compact)
  depth: number // 0..1 (0=overview, 1=detailed)
  motion: number // 0..1 (0=minimal, 1=rich)
}

export interface UXState {
  persona: Persona
  axes: Axes
  demo: boolean
  theme: Theme
  locale: Locale
}

export const PERSONA_PRESETS: Record<Persona, Axes> = {
  recruiter: { density: 0.3, depth: 0.2, motion: 0.5 },
  engineer: { density: 0.7, depth: 0.8, motion: 0.3 },
}

export type VariantComponent = 'Hero' | 'ProjectCard' | 'Skills' | 'ProjectDetail'

export type Variant = string // e.g., 'RecruiterHero', 'EngineerHero', etc.
